module.exports = __webpack_public_path__ + "img/left.53ab5011.png";